export default {
  path: '/body',
  name: 'Body',
  redirect: '/body/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/body'),
      meta: { requiresAuth: true }
    },
    {
      path: 'info',
      component: () => import('@/views/body/components/Info'),
      meta: { requiresAuth: true }
    }
  ]
}
